module.exports = __webpack_public_path__ + "img/B3AA93_F4EFD7_E1DDC2_DCD3BB-256px.dea6bb83.png";